import { useEffect, useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useLocalStorage } from 'usehooks-ts';
import { z } from 'zod';
import { parseUrlParam } from '~/components/Filter';

const TAG_SCHEMA = z.array(z.string());

export const getShowFiltersParams = (searchParams: URLSearchParams) => ({
  tags: parseUrlParam(() => TAG_SCHEMA.parse(JSON.parse(searchParams.get('tags') || '[]')), 'tags'),
});

export const useShowFiltersParams = () => {
  const [searchParams] = useSearchParams();
  const [_, setSavedParamsString] = useLocalStorage('shows:filters', '');

  // Save to local storage whenever URL params change
  useEffect(() => {
    setSavedParamsString(() => searchParams.toString());
  }, [searchParams, setSavedParamsString]);

  return useMemo(() => getShowFiltersParams(searchParams), [searchParams]);
};
